module.exports = __webpack_public_path__ + "img/MathematicsLogo.358c639f.svg";